import Rule from "../../../common/rule";
import FootballState from "../../state/football-state";

export default class SetTimeAndPeriod extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return fragment.associatedState === FootballState.SetTimeAndPeriod;
    }
    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { milliseconds } = fragment.timeAndPeriod;
        gameContext.setClockSeconds(milliseconds / 1000);
    }
}
